//import { mq } from '../../cssInJs';

export function getShareButtonStyle() {
  return {
    shareButtons: {
      marginTop: '1.5rem',
    },
    shareButtonTitle: {
      fontSize: '0.8rem',
      marginBottom: '0.3rem'
    },
    shareButton: {
      margin: 5
    },
    shareButtonsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  }
} 
